import React from 'react';

function ContactSection() {
  return (
    <section id="contact">
        <h2>Contact Me</h2>
        <p>Feel free to reach out for collaborations or inquiries!</p>
        <ul>
            <li>Email: info@alvarezsm.com</li>
            <li>LinkedIn: <a href="https://port.alvarezsm.com/">LinkedIn</a></li>
            <li>GitHub: <a href="https://port.alvarezsm.com/">GitHub</a></li>
        </ul>
    </section>
  );
}

export default ContactSection;
